<mce-page-with-navigation>
    <div class="flex flex-col gap-4">
        <app-profile></app-profile>

        @if (isSharedBillingMember()) {
        <app-shared-billing></app-shared-billing>
        }

        @if (showSubscription()) {
        <div><mce-account-subscription></mce-account-subscription></div>
        }

        @if (!isSharedBillingMember()) {
        <div><app-balance></app-balance></div>
        }
    </div>
</mce-page-with-navigation>
